import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

class InlineField extends Component {

  render () {
    let { intl, translation, value, content, label, id, fieldType, link, docType } = this.props;

    let inlineField;

    if (intl && translation) {
      const labelObj = translation.label;
      if(labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
    }

    let labelComponent = label ? <label style={{ color: "#004a23" }}>{ label }</label> : null;
    let fieldContent;

    if ( content ) {
      fieldContent = content;
    } else {
      fieldContent = label ? `No ${label}` : null;
    }

    switch ( fieldType ) {

      case 'renderField' :
      case 'renderTextArea' :
      case 'renderPickerMaxField' :
      case 'renderPickerMinField' :
      case 'renderDatePickerField' :
      case 'renderActionInputField' :
      case 'renderDatePickerMinTodayField' :
        inlineField = (
          <div className={`field`} id={id} >
            { labelComponent }
            <p>{ fieldContent }</p>
          </div>
        )
      break;

      case 'renderFieldURL' :

        let linkTag = fieldContent;

        if ( fieldContent !== `No ${label}` ) {
          linkTag = <a href={ fieldContent } >{ fieldContent }</a>
        }

        inlineField = (
          <div className={`field`} id={id} >
            { labelComponent }
            <p>{ linkTag }</p>
          </div>
        )
        
      break;

      case 'renderToggle':
      case 'renderSlider':
        inlineField = (
          <div className={`field`}>
            <label style={{ display: "inline", color: "#004a23" }}>{ label }: </label><p style={{ display: "inline" }} >{ content ? <FormattedMessage id="admin.title.yes" /> : <FormattedMessage id="admin.title.no" /> }</p>
          </div>
        )
      break;

      case 'renderInteger':
      case 'renderDecimal':
        inlineField = (
          <div className={`field`} id={id} >
            { labelComponent }
            <p>{content ? content : 0 }</p>
          </div>
        )
      break;

      case 'renderCheckBox':
      case 'renderSimpleCheckbox':
        inlineField = (
          <div className="checkbox-view-field field" id={id} >
            { labelComponent }
            <div>
              { content ? <FormattedMessage id="admin.title.yes" /> : <FormattedMessage id="admin.title.no" /> }
            </div>
          </div>
        )
      break;

      case 'renderDropdownField':
      case 'renderDropdownMultipleField':
      case 'renderActionMultipleDropDownField':
        inlineField = inlineDropdownField( value, content, label, id, link, docType );
      break;

      default:
        inlineField = (
          <div className={`field`} id={id} >
            { labelComponent }
            <p>{ fieldContent }</p> 
          </div>
        )
      break;
    }

    return inlineField;
  }

}

const inlineDropdownField = ( value, content, label, id, link, docType ) => {

  let fieldContent;
  let labelComponent = label ? <label style={{ color: "#004a23" }}>{ label }</label> : null;

  if ( !isEmpty( value ) && !isEmpty( content ) ) {
    if ( Array.isArray( content ) ) {
      fieldContent = content.map( ( elem, i ) => {
        if ( link ) {
          const link = linkCreator( docType, value[i] );
          if( i === content.length - 1 ){            
            return <a href={link} >{ elem } </a>
          }
          return <a href={link} >{ elem }, </a>
        } else {
          if( i === content.length - 1 ){            
            return `${ elem } `;
          }
          return `${ elem }, `;
        }
      })
    } else {
      if ( link ) {
        const link = linkCreator( docType, value );
        fieldContent = <a href={link} >{ content }</a>;
      } else {
        fieldContent = content;
      }
    }
  } else {
    fieldContent = label ? `No ${label}` : null;
  }

  return (
    <div className="field">
      { labelComponent }
      <p>
        { fieldContent }
      </p>
    </div>
  )

}

const linkCreator = ( docType, docId ) => {

    const base_url = window.location.origin;
    const links = {
      tax_code         : '/admin/tax_code/view/',
      roles            : '/admin/role/view/',
      employee         : '/admin/employee/view/',
      customer         : '/admin/customer/view/',
      contact          : '/admin/contact/view/',
      supplier         : '/admin/supplier/view/',
      pricebook        : '/admin/pricebook/view/',
      location         : '/admin/location/view/',
      subsidiary       : '/admin/subsidiary/view/',
      hotkey           : '/admin/hotkey/group/view/',
      currency         : '/admin/currency/view/',
      device           : '/admin/device/view/',
      classification   : '/admin/classification/view/',
      payment_type     : '/admin/payment_type/view/',
      matrix_attribute : '/admin/matrix/definition/view/',
      promotion        : '/admin/promotion/view/',
      task             : '/admin/task/view/',
      region           : '/admin/region/view/',
      exchange_rate    : '/admin/exchange_rate/view/',
      print_template   : '/admin/print_template/view/',
    }
  
    return base_url + links[docType] + docId;
  }

  export default injectIntl(InlineField);